// CustomSkeleton.js
import React from "react";

function CustomSkeleton({ height, width, className = "", style = {} }) {
  const defaultStyle = {
    height,
    width,
    borderRadius: "4px",
    backgroundColor: "#e0e0e0",
    animation: "skeleton-loading 1.5s infinite",
    ...style,
  };

  return <div className={`custom-skeleton ${className}`} style={defaultStyle} />;
}

export default CustomSkeleton;
